export function useQuery() {
    const queryParams = new URLSearchParams(location.search);    
    return queryParams
}
